
import { BaseSearchModel } from './base.search.model';
export class SearchMusicModel extends BaseSearchModel {
    public key: string;
    public genre: string;
    public artist: string;
    public album: string;
    public isSystem: number;
}
